<script>
  import options from './UploadNewFileOverlay.options'
  export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-overlay-styles kb-upload-new-file-overlay" :class="{ 'kb-overlay-styles--submitting': isSubmitting }">
      
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <div class="kb-overlay-styles__hero">
          <div class="kb-overlay-styles__hero-wrapper">
            <h4 class="kb-overlay-styles__hero-title">{{ getLabel('title') }}</h4>
          </div>
        </div>

        <div class="kb-overlay-styles__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        <div class="kb-overlay-styles__form-content kb-stafet-donation-flow">

          <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

            <div class="kb-stafet-step__input-wrapper">

              <div class="kb-create-post__files" v-if="file?.url">
    
                  <div class="kb-create-post__files-content-wrapper">
                    <div class="kb-create-post__files-content-wrapper-left">
                      <figure class="kb-create-post__files-image kb-image-module">
                        <div class="kb-image-module__image-container">
                          <picture class="kb-image-module__image">
                            <img :src="file.url" alt="file image" />
                          </picture>
                        </div>
                      </figure>
                    </div>
                    <div class="kb-create-post__files-content-wrapper-right">
                      <div class="kb-create-post__files-details-wrapper">
                        <p>{{ file.name }}</p>
                        <p>{{ getLabel('fileSizeLabel') }}: {{ (file.size / 1024 / 1000).toFixed(3) }} MB</p>
                      </div>
                      <button class="kb-button kb-button--full-color-spot kb-create-post__files-delete-button kb-js--delete-uploaded-file-card" v-on:click="() => removeFile()">{{
                        getLabel('fileButtonRemove') }}</button>
                    </div>
                  </div>
                
              </div>
  
              <div class="kb-create-post__file-upload"
                :class="displayError ? 'kb-create-post__file-upload--error' : ''">
                <label class="kb-form__file-upload FormFileUpload" for="postImages">
                  <input class="kb-form__file-upload-input FormFileUpload__Input" id="postImages" type="file"
                    v-on:change="(e) => (onFileChange(e))" />
                  <div class="kb-form__file-upload-svg">
                    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity=".4" fill="#3C3C3C">
                        <path
                          d="m20.024 13.05.967-.405-.206-.481c-.84-2.002-.617-4.14.596-5.683 1.214-1.542 3.095-2.264 5.32-2.093l-1.49 1.438.73.75 2.016-1.961a1.008 1.008 0 0 0 0-1.44l-2.016-1.961-.73.75 1.396 1.357c-2.505-.133-4.674.757-6.049 2.518-1.451 1.856-1.72 4.375-.736 6.72l.203.49ZM18.141 24.419v1.046h-5.93v-1.046H.699v2.965a1.214 1.214 0 0 0 1.221 1.22h26.163a1.22 1.22 0 0 0 1.22-1.22v-2.965H18.142Zm10.116 2.965a.174.174 0 0 1-.174.174H1.92a.178.178 0 0 1-.125-.052.175.175 0 0 1-.05-.122v-1.919h9.42v1.047h8.023v-1.047h9.07v1.919ZM4.886 21.977H2.793V9.593a.174.174 0 0 1 .174-.174h14.128V8.372H2.967a1.22 1.22 0 0 0-1.22 1.221v13.43h3.139v-1.046Z" />
                        <path
                          d="M28.256 23.023V9.593a1.22 1.22 0 0 0-1.22-1.22h-4.013v1.046h4.012a.174.174 0 0 1 .174.174v13.43h1.047Z" />
                      </g>
                    </svg>
                  </div>
                  <div class="kb-form__file-upload-text-wrapper">
                    <p class="kb-form__file-upload-text">
                      {{ getLabel("uploadTitle") }}
                    </p>
                    <small class="kb-form__file-upload-format-types">{{
                      getLabel("uploadFormats")
                    }}</small>
                  </div>
                </label>
                <p v-if="displayError" class="kb-forms Form__Element__ValidationError">{{ getLabel('fileUploadError') }}</p>
              </div>

            </div>

            <nav class="kb-stafet-flow-actions">
              <div class="kb-stafet-flow-actions__buttons-left-wrapper">
                <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot"
                  v-on:click="submitUploadNewFile">
                  {{ getLabel("submitFileButtonText") }}
                </button>
              </div>
            </nav>

          </section>

        </div>

      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>

    </article>

  </div>

</template>
